/** Tipo destinazione per dirottamento */
export enum DeviationDestinationTypeEnum {
  // Destinatario
  RECIPIENT = 1,
  // Mittente
  SENDER = 2
}

/** Tipo dirottamento */
export enum DeviationTypeEnum {
  // Parziale su nuova destinazione
  PARTIAL_DESTINATION_NEW = "1",
  // Parziale su destinazione del viaggio
  PARTIAL_DESTINATION_INTRIP = "2",
  // Totale su nuova destinazione
  TOTAL_DESTINATION_NEW = "3",
  // Totale su destinazione del viaggio
  TOTAL_DESTINATION_INTRIP = "4"
}

/** Tipo di gruppi di eventi sottoscrivibili */
export enum GenericEventDataNotificationGroupEnum {
  contractNotification = "contractNotification",
  orderNotification = "orderNotification",
  tripNotification = "tripNotification",
  tripToChangeNotification = "tripToChangeNotification",
  userNotification = "userNotification"
}

/** Tipo di shape del marker */
export enum MarkerShapeTypeEnum {
  /** Normale */
  CIRCLE = 1,
  /** Rettangolare */
  SQUARE = 2,
  /** Stella */
  STAR = 3,
  /** Pentagono */
  PENTA = 4
}

/** Tipo di marker */
export enum MarkerTypeIdEnum {
  /** Deposito */
  DEPOT = 1,
  /** Garage */
  GARAGE = 2,
  /** Ordine */
  ORDER = 3,
  /** Destinazione (punto vendita) */
  DESTINATION = 4,
  /** Viaggio */
  TRIP = 5,
  /** Fermata (non consegna) */
  STOP = 6,
  /** Fermata (consegna) */
  STOPDELIVERY = 7,
  /**  Partenza */
  TRIPSTART = 8,
  /** Punto di carico */
  TRIPLOAD = 9,
  /** Rientro viaggio */
  TRIPRETURN = 10,
  /** Service */
  SERVICE = 11
}

/** Modalità di selezione su mappa */
export enum MapTripModeEnum {
  Standard = 1,
  TripCreate = 2
}

/** Modalità di pagamento */
export enum PaymentTypeEnum {
  /** Contanti */
  CASH = 1,
  /** Assegno */
  CHECK = 2,
  /** Bonifico */
  TRANSFER = 3
}

/** Definisce la modalità di inserimento valori in modifica quantità prodotto */
export enum ProductInputFactorEnum {
  KL = 1000,
  L = 1
}

/** Tipo di terminal */
export enum TerminalTypeEnum {
  /** Deposito */
  DEPOT = 1,
  /** Garage */
  GARAGE = 2
}

/** Eventuale tipo di contratto associato all'unità di trasporto */
export enum TransportUnitContractTypeEnum {
  /** Nessuno*/
  NONE = 0,
  /** Spot */
  SPOT = 1
}

/** Enumerable stato trasmissione viaggio */
export enum TransmissionStatusEnum {
  // Da trasmettere
  TOBETRANSMITTED = 0,
  // Inviato
  SENT = 1,
  // Non inviato
  NOTSENT = -1,
  // Non trasmesso
  NOTTRANSMITTED = -2,
  // Trasmesso
  TRANSMITTED = 2
}

/** Tipologie di creazione viaggi da ordini */
export enum TripCreateMultipleFromOrderListTypeEnum {
  /// Si presenta la necessità di creare un certo numero di viaggi con all'interno un singolo ordine.
  /// Avvia la creazione di tanti viaggi quanti sono gli ordini scelti allocando un solo ordine per viaggio
  SINGLEORDER = 1,
  /// Uguale al caso 1 <see cref="SINGLEORDER"/> con la variante che viene selezionato anche un veicolo.
  /// Ai viaggi creati viene assegnato il veicolo selezionato.
  SINGLEORDER_WITHVEHICLE = 2,
  /// Viene selezionata una serie di ordini
  /// Creazione di tanti viaggi quanti ne servono per allocare tutti gli ordini selezionati ottimizzando il numero di viaggi con le informazioni di un veicolo generico
  /// È lo stesso processo che utilizza l'ottimizzatore ma più ridotto
  ORDERALLOCATION = 3,
  /// Lo stesso del caso 3 <see cref="ORDERALLOCATION"/> ma allocando anche i veicoli disponibili e non utilizzati negli altri viaggi già presenti
  ORDERALLOCATION_FREEVEHICLE = 4
}

/** Enumerable che descrive i tipi di percorsi da mostrare una volta selezionato il viaggio */
export enum TripRouteViewEnum {
  /** Nessuno */
  NONE = 0,
  /** Calcolato (ideale) */
  CALCULATED = 1,
  /** Effettivo (reale, effettivamente percorso) */
  EFFECTIVE = 2,
  /** Entrambi */
  BOTH = 3
}

/**
 * Enumerable tipo di fermata
 * Utilizza i medesimi ID del tipo marker
 */
export enum TripStopDestinationTypeEnum {
  // Deposito
  DEPOT = 1,
  // Garage
  GARAGE = 2,
  // Punto vendita
  STORE = 4
}

/** Tipo di fermata del viaggio */
export enum TripStopTypeEnum {
  // Partenza
  START = 0,
  // Consegna
  DELIVERY = 1,
  // Carico
  LOAD = 2,
  // Rientro
  RETURN = 3,
  // Sosta
  BREAK = 4,
  // Servizio
  SERVICE = 5,
  // Altro
  OTHER = 6,
  // Consegna di scorta
  DELIVERYBUFFER = 7
}

/** Tipologia del veicolo */
export enum VehicleTypeEnum {
  /** Trattore (aggancia un rimorchio) */
  TRACTOR = 1,
  /** Rimorchio (agganciato ad un trattore) */
  TRAILER = 2,
  /** Motrice (aggancia un semirimorchio) */
  TRUCK = 3,
}
